import { render, staticRenderFns } from "./BizAddService.vue?vue&type=template&id=c4722e66&scoped=true"
import script from "./BizAddService.vue?vue&type=script&lang=js"
export * from "./BizAddService.vue?vue&type=script&lang=js"
import style0 from "./BizAddService.vue?vue&type=style&index=0&id=c4722e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4722e66",
  null
  
)

export default component.exports